// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles__spinner___3O5pA"};